import { Box } from '@televet/kibble-ui/build/chakra';
import { Menu, MenuItemProps, MenuListOnSelectAll } from '@televet/kibble-ui/build/components/Menu';
import React from 'react';

interface ColumnFilterMenuProps {
  menuItems: MenuItemProps[];
  onSelectAll: MenuListOnSelectAll;
  onOpen?: () => void;
}

const ColumnFilterMenu = ({ menuItems, onSelectAll, onOpen }: ColumnFilterMenuProps): JSX.Element => {
  return (
    <Box className="PaymentReport__ColumnFilterMenu">
      <Menu
        isLazy
        buttonProps={{
          leftIconName: 'eyeOpen',
          variant: 'secondary',
          size: 'sm',
          text: 'Show',
        }}
        onOpen={onOpen}
        listProps={{
          canSelectAll: true,
          menuItems,
          isMultiSelect: true,
          onSelectAll,
        }}
      />
    </Box>
  );
};

const customComparator = (prevProps: ColumnFilterMenuProps, nextProps: ColumnFilterMenuProps): boolean =>
  JSON.stringify(prevProps.menuItems) === JSON.stringify(nextProps.menuItems);

export default React.memo(ColumnFilterMenu, customComparator);
